import React, { Component } from "react";

class UploadCSVComplete extends Component {
  render() {
    return (
      <div
        className="flex flex-col w-full items-center justify-center font-inter gap-5 rounded-2xl p-10 border-2 border-dashed border-blue-200 transition-all duration-200"
        style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 60%, #eef2ff 100%)" }}
      >
        {/* Spinner */}
        <div className="relative flex items-center justify-center w-12 h-12">
          <div className="absolute w-full h-full border-2 border-t-transparent border-primary-blue rounded-full animate-spin"></div>
          <div className="flex items-center justify-center bg-white w-9 h-9 rounded-full z-10 text-xs font-semibold text-primary-blue">
            100%
          </div>
        </div>
        <div className="flex flex-col gap-2 items-center text-center">
          <p className="text-sm font-medium text-gray-700">Getting Ready...</p>
          <p className="text-xs text-gray-400">Preparing your analysis</p>
        </div>
      </div>
    );
  }
}

export default UploadCSVComplete;
